export default "__VITE_ASSET__DKUwl5HG__"